import { render, staticRenderFns } from "./ReservationIsCreated.vue?vue&type=template&id=5dc58156"
import script from "./ReservationIsCreated.vue?vue&type=script&lang=js"
export * from "./ReservationIsCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports